// import { useQuery } from '@tanstack/react-query';
// import { mainCategoryServices } from '../services/main-category.service';

// export const useMainCategories = ({
//   page,
//   limit,
//   level,
//   search,
//   sortBy,
//   isActive,
//   sortOrder,
//   isPopular,
//   isFeatured,
// }) => {
//   return useQuery({
//     queryKey: ['main-category', { page, limit, level, search, sortBy, sortOrder, isActive, isPopular, isFeatured }],
//     queryFn: () =>
//       mainCategoryServices.getMainCategories({
//         page,
//         limit,
//         level,
//         search,
//         sortBy,
//         sortOrder,
//         isActive,
//         isPopular,
//         isFeatured,
//       }),
//     staleTime: 5 * 60 * 1000, // 5 minutes
//     gcTime: 10 * 60 * 1000, // 10 minutes
//     keepPreviousData: true,
//   });
// };


import { useQuery } from '@tanstack/react-query';
import { mainCategoryServices } from '../services/main-category.service';

/**
 * Reusable API error parser
 */
const parseApiError = (error) => {
  return {
    message:
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Something went wrong',

    status: error?.response?.status || 500,

    errors: error?.response?.data?.errors || [],
  };
};

/**
 * Get all main categories
 */
export const useMainCategories = ({
  page,
  limit,
  level,
  search,
  sortBy,
  isActive,
  sortOrder,
  isPopular,
  isFeatured,
}) => {
  return useQuery({
    queryKey: [
      'main-category',
      {
        page,
        limit,
        level,
        search,
        sortBy,
        sortOrder,
        isActive,
        isPopular,
        isFeatured,
      },
    ],

    queryFn: async () => {
      try {
        return await mainCategoryServices.getMainCategories({
          page,
          limit,
          level,
          search,
          sortBy,
          sortOrder,
          isActive,
          isPopular,
          isFeatured,
        });
      } catch (error) {
        throw parseApiError(error);
      }
    },

    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes

    placeholderData: (previousData) => previousData,

    retry: 1,
  });
};